// extracted by mini-css-extract-plugin
export default {"textInput":"CategoryEditBasicSection_textInput__2C+ls","flag":"CategoryEditBasicSection_flag__CQeB1"};